import api from "./api";
import { IInstallations } from 'config/interfaces';

interface Set {
  IDMCM: number,
  DSMCM: string
}

const getAllShort = () => {
  return api.get<IInstallations.Installation[]>(`/api_front/MCMInstall`);
}

const getOne = (installationId: string = 'ABC-4321') => {
  return api.get<Set[]>(`/api_front/MCMSiteSearch/${installationId}`);
}

export { getAllShort, getOne }